import { render } from "./faq-page.vue?vue&type=template&id=05eb60e6&scoped=true"
import script from "./faq-page.vue?vue&type=script&lang=js"
export * from "./faq-page.vue?vue&type=script&lang=js"

import "./faq-page.vue?vue&type=style&index=0&id=05eb60e6&scoped=true&lang=css"
import "./faq-page.vue?vue&type=style&index=1&id=05eb60e6&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05eb60e6"]])

export default __exports__